import {Component, EventEmitter, Input, Output, SimpleChanges} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
   DkNavService,
  DynamicButton,
  FormDto,
  ScreenService
} from "@dabnet-kamu/libs/ui";
import {
  DxButtonModule,
  DxDropDownButtonModule,
  DxSelectBoxModule,
  DxTabsModule,
  DxToolbarModule
} from "devextreme-angular";
import {DxiItemModule} from "devextreme-angular/ui/nested";
import {DxButtonTypes} from "devextreme-angular/ui/button";
import Button from "devextreme/ui/button";

@Component({
  selector: 'dk-grid-bottom-toolbar',
  standalone: true,
  imports: [CommonModule, DxButtonModule, DxDropDownButtonModule, DxToolbarModule, DxiItemModule, DxSelectBoxModule, DxTabsModule],
  templateUrl: './grid-bottom-toolbar.component.html',
  styleUrls: ['./grid-bottom-toolbar.component.scss'],
})
export class GridBottomToolbarComponent {@Input() public state: string;
  @Input() disable: boolean;
  @Input() disableDonem: boolean;
  @Input() chevron: boolean= false;
  @Input() public twoLineEnable: boolean= false
  @Input() donemAktif = true;
  @Input() selectedPeriodId!: number;
  @Input() actionMenuElement: any[];
  @Input() formMetaData?: FormDto;
  @Input() dynamicButtons: DynamicButton[];
  @Output() dynamicButtonClicked = new EventEmitter<void>();
  @Output() chevronButtonClicked = new EventEmitter<void>();

  showDynamicButtons = true;
  chevronButtonOptions: DxButtonTypes.Properties = {
    stylingMode: 'contained',
    type: 'default',
    icon: 'expandform',
    onClick: () => {
     this.chevronButtonClicked.emit()
    },
  };

  constructor(public screen: ScreenService,
              private navService: DkNavService) {
  }
  ngOnChanges(changes: SimpleChanges): void {

    if(changes['dynamicButtons']){
      if(this.dynamicButtons) this.showDynamicButtons = true;
      else this.showDynamicButtons = false;
    }
  }


  handleDynamicButtonClick(dynamicButton: any) {
    if(!dynamicButton.disabled) this.dynamicButtonClicked.emit(dynamicButton)
  }


  trackByFn(index: number, item: any): any {
    return item.id; // Eğer her butonun benzersiz bir 'id'si varsa onu kullanın
  }

  onContentReady(e: any) {
    let buttonElement = e.element.querySelectorAll(
      ".dx-toolbar-menu-container .dx-dropdownmenu-button"
    )[0];

    let buttonInstance = Button.getInstance(buttonElement);

    buttonInstance.option("icon", "menu");
    buttonInstance.option("hint", "Diğer İşlemler"); // tooltip
  }
}
